// Atualize este número (SYSTEM_VERSION) toda vez que fizer uma nova atualização ou correção no sistema.
// Isso forçará o navegador dos usuários a limpar o cache antigo e recarregar a versão mais recente.
export const SYSTEM_VERSION = "v3.0.25";
